import reactComponentLoader from 'scripts/react-component-loader'

import Cart from 'frontendCheckout/pages/cart'

reactComponentLoader(Cart, '[data-checkout-cart]')
